import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Activity, Baby, TestTube, Eye, HeartPulse, Stethoscope, Syringe, Users, Calendar, PersonStanding } from 'lucide-react';
import { ToothIcon } from '../icons/ToothIcon';
const TOP_SERVICES = [{
  title: 'General Consultations',
  icon: <Stethoscope className="w-7 h-7" data-id="element-210" data-mp="116cj7x3te43s" />,
  desc: 'Expert medical advice and treatment for common illnesses and health concerns.',
  slug: 'general-medical-consultations'
}, {
  title: 'Maternal Care',
  icon: <Baby className="w-7 h-7" data-id="element-211" data-mp="s8ajrlzqbjim" />,
  desc: 'Comprehensive antenatal and postnatal care for mothers and babies.',
  slug: 'antenatal-care'
}, {
  title: 'Laboratory Services',
  icon: <TestTube className="w-7 h-7" data-id="element-212" data-mp="i9bco7um3vxq" />,
  desc: 'Accurate and fast diagnostic testing including blood work and DNA testing.',
  slug: 'laboratory-services'
}, {
  title: 'Diagnostics & Screening',
  icon: <Activity className="w-7 h-7" data-id="element-213" data-mp="2clrorpa3a4ai" />,
  desc: 'Comprehensive diagnostic testing including ECG, ultrasound, hearing and lung function assessments.',
  slug: 'ultrasound-services'
}, {
  title: 'Chronic Disease',
  icon: <HeartPulse className="w-7 h-7" data-id="element-214" data-mp="1mulfnfnhzx05" />,
  desc: 'Ongoing management and support for diabetes, hypertension, and more.',
  slug: 'chronic-disease-management'
}, {
  title: 'Optician Services',
  icon: <Eye className="w-7 h-7" data-id="element-215" data-mp="18wn7wt3omytm" />,
  desc: 'Professional eye examinations and vision care solutions.',
  slug: 'optician-services'
}, {
  title: 'Immunizations',
  icon: <Syringe className="w-7 h-7" data-id="element-216" data-mp="13zoeydvr8xx0" />,
  desc: 'Essential vaccines for children and adults to prevent infectious diseases.',
  slug: 'immunizations'
}, {
  title: 'Family Planning',
  icon: <Users className="w-7 h-7" data-id="element-217" data-mp="1dxueiou39ryp" />,
  desc: 'Confidential counseling and contraceptive services for family planning.',
  slug: 'family-planning'
}, {
  title: 'Physiotherapy',
  icon: <PersonStanding className="w-7 h-7" data-id="element-218" data-mp="2pan3jrvhw2b2" />,
  desc: 'Personalized physiotherapy services focused on improving mobility, managing pain, supporting recovery, and enhancing quality of life.',
  slug: 'physiotherapy'
}];
export function ServicesOverview() {
  return <section className="py-20 bg-brand-lighter" data-id="element-219" data-mp="1vz89i1e7j83o">
      <div className="max-w-brand mx-auto px-4 sm:px-6 lg:px-8" data-id="element-220" data-mp="1vwcccfa6onga">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6" data-id="element-221" data-mp="1zz8njkxe9ha7">
          <div className="max-w-2xl" data-id="element-222" data-mp="13asydpy759xm">
            <span className="text-brand-red font-semibold tracking-wider text-sm uppercase mb-3 block" data-id="element-223" data-mp="137ome6ehp9we">
              Our Services
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-navy mb-4" data-id="element-224" data-mp="1c9eab295xqpf">
              Comprehensive Healthcare Solutions
            </h2>
            <p className="text-slate-600 text-lg" data-id="element-225" data-mp="kj9tfdkm3lsy">
              We offer a wide range of medical services under one roof, ensuring
              you and your family receive complete care.
            </p>
          </div>
          <Link to="/services" className="inline-flex items-center gap-2 text-brand-navy font-semibold hover:text-brand-red transition-colors shrink-0" data-id="element-226" data-mp="h1ccdxmd6mfs">
            View All Services <ArrowRight className="w-5 h-5" data-id="element-227" data-mp="7zcuz47ftgcb" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-228" data-mp="31l1i5r59m60">
          {TOP_SERVICES.map((service, idx) => <div key={idx} className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-soft-lg transition-shadow duration-300 border border-slate-100 group relative overflow-hidden flex flex-col" data-id="element-229" data-mp="3u8nsaw32lqfp" data-mpi={idx}>
              <div className="absolute top-0 left-0 w-full h-1 bg-brand-red transform -translate-x-full group-hover:translate-x-0 transition-transform duration-500 ease-out" data-id="element-230" data-mp="3kfqa6r1zq3hm" />

              <div className="w-14 h-14 bg-brand-light rounded-xl flex items-center justify-center mb-6 text-brand-gold group-hover:scale-110 transition-transform duration-300" data-id="element-231" data-mp="3bglbnkqfia5g">
                {service.icon}
              </div>

              <h3 className="text-xl font-heading font-bold text-brand-navy mb-3 group-hover:text-brand-red transition-colors" data-id="element-232" data-mp="1ah9eacaxaidh">
                {service.title}
              </h3>

              <p className="text-slate-600 text-sm mb-6" data-id="element-233" data-mp="10otvxdvprrs2">
                {service.desc}
              </p>

              <div className="flex items-center justify-between mt-auto pt-4 border-t border-slate-50" data-id="element-234" data-mp="15m3r7a5saxnt">
                <Link to={`/services/${service.slug}`} className="text-sm font-medium text-brand-navy hover:text-brand-red transition-colors" data-id="element-235" data-mp="rqrz7aj0jlal">
                  Learn More
                </Link>
                <Link to={`/book?service=${service.slug}`} className="w-8 h-8 rounded-full bg-brand-lighter flex items-center justify-center text-brand-navy hover:bg-brand-red hover:text-white transition-colors" data-id="element-236" data-mp="mqdo1jm47v8c">
                  <ArrowRight className="w-4 h-4" data-id="element-237" data-mp="5g02szj8crso" />
                </Link>
              </div>
            </div>)}

          {/* Dentistry */}
          <div className="md:col-span-1 lg:col-span-3 bg-white rounded-2xl p-6 md:p-8 shadow-sm hover:shadow-soft-lg transition-shadow duration-300 border border-slate-100 group relative overflow-hidden flex flex-col lg:flex-row lg:items-center gap-6 lg:gap-10" data-id="element-238" data-mp="igndwasq8z5">
            <div className="absolute top-0 left-0 w-full h-1 bg-brand-red transform -translate-x-full group-hover:translate-x-0 transition-transform duration-500 ease-out" data-id="element-239" data-mp="o5yh3xdmfh4r" />

            <div className="flex items-start gap-5 flex-1" data-id="element-240" data-mp="y4nq10njhr8v">
              <div className="w-14 h-14 bg-brand-light rounded-xl flex items-center justify-center text-brand-gold shrink-0 group-hover:scale-110 transition-transform duration-300" data-id="element-241" data-mp="y45n5l6dgerz">
                <ToothIcon className="w-7 h-7" data-id="element-242" data-mp="2zx29431tl1qv" />
              </div>
              <div data-id="element-243" data-mp="2ux7fhrqnty24">
                <h3 className="text-xl md:text-2xl font-heading font-bold text-brand-navy mb-2 group-hover:text-brand-red transition-colors" data-id="element-244" data-mp="2uxpgt2s6j2gw">
                  Dentistry
                </h3>
                <p className="text-slate-600 text-sm md:text-base max-w-xl" data-id="element-245" data-mp="3olwrdqljse0z">
                  Comprehensive dental care focused on maintaining healthy
                  teeth, gums, and confident smiles.
                </p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 shrink-0" data-id="element-246" data-mp="2d3xbfazvif0">
              <Link to="/services/dentistry" className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-brand-navy text-brand-navy text-sm font-semibold px-5 py-2.5 whitespace-nowrap hover:bg-brand-navy hover:text-white transition-colors" data-id="element-247" data-mp="7e1mwcyc3eqj">
                View Dentistry Services <ArrowRight className="w-4 h-4" data-id="element-248" data-mp="q51ab9q6kghp" />
              </Link>
              <Link to="/book?service=dentistry" className="inline-flex items-center justify-center gap-2 rounded-full bg-brand-red text-white text-sm font-semibold px-5 py-2.5 whitespace-nowrap hover:bg-brand-navy transition-colors" data-id="element-249" data-mp="q6vqybuf5mfz">
                <Calendar className="w-4 h-4" data-id="element-250" data-mp="2alii59q4ay52" /> Book Appointment
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}